import { render } from "./SideBar.vue?vue&type=template&id=b9098052&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=b9098052&lang=css"
import "./SideBar.vue?vue&type=style&index=1&id=b9098052&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9098052"]])

export default __exports__